import { render, staticRenderFns } from "./JoinBriefing.vue?vue&type=template&id=105db41a"
import script from "./JoinBriefing.vue?vue&type=script&lang=js"
export * from "./JoinBriefing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports